import general from './general'
import address from './address'
import passengers from './passengers'

export default {
  ...general,
  address,
  passengers,
}
